import { Commands } from '../../commands/CommandEnum';
import CommandManager from '../../commands/CommandManager';
import PointerEvents from '../../const/PointerEvents';
import { SettingsButtons } from '../../const/SettingsButtons';
import SoundVars from '../../const/SoundVars';
import InstanceFactory from '../../factories/InstanceFactory';
import IRulesScenes from '../../managers/contracts/configurations/settings/IRulesScenes';
import BetModel from '../../model/BetModel';
import GameModel from '../../model/GameModel';
import Layout from '../../utils/Layout';
import Locale, { LocaleId } from '../../utils/Locale';
import SoundController from '../../utils/SoundController';
import Utils from '../../utils/Utils';
import Button from '../../views/components/Button';
import SwitchButton from '../../views/components/SwitchButton';
import TextField from '../../views/components/TextField';
import { MoneyField } from '../../views/MoneyField';
import SceneView from '../../views/SceneView';
import BaseSettings from '../BaseSettings'
import BaseUI from '../BaseUI';
import { UIStates } from '../UIStates';
import IRulesScenesCount from '../../contracts/IRulesScenesCount';
import { VendorCommandsEnum } from '../../../../src/commands/VendorCommandsEnum';
import UIUtils from "../../../../core/src/utils/UIUtils";
import App from '../../App';
import ConsoleUtil from '../../utils/ConsoleUtil';
import { UIButtons } from '../UIButtons';
import { DefaultLayers } from '../../utils/Layers';
import ViewManager from '../../utils/ViewManager';
import Cursor from '../../views/components/Cursor';
import { Container } from 'pixi.js';
import GameEvents from '../../const/GameEvents';
import JackpotsModel from '../../../../src/model/JackpotsModel';
import Configs from '../../../../src/vendorConfigs/Configs';

export default class PageSettings extends BaseSettings {
    public paytablePageScenes: string[];
    public payTablePage: number = 1;
    public currentSettingsPage: string;
    protected _minFontSizePortrait: number | string = null;
    protected _minFontSizeLandscape: number | string = null;
    protected pages: Map<string, () => void> = new Map();
    protected leftArrow: Button;
    protected rightArrow: Button;
    private preInitializeRunning: boolean = false;
    constructor() {
        super();
        App.dispatcher.on(GameEvents.ASSETS_LOADED, () => {
            const interfaceScene: SceneView = this.interfaceLayer.setScene('open');
            interfaceScene.visible = false;
            const sceneButtons: Map<string, Button> = interfaceScene.buttons;
            const hasOptionsButton: boolean = sceneButtons.has(SettingsButtons.OPTIONS);
            const hasSoundButton: boolean = sceneButtons.has(SettingsButtons.SOUND);

            this.setupOptions(hasOptionsButton, hasSoundButton);
        })
        this.setPages();
        this.setNavigationActions();

        // remove when settings are done
        this.defaultPage = "settings";

        if (!Configs?.settings?.offOrientationChangePopup) {
            window.addEventListener("orientationchange", function () {
                if (!this.isHidden && !this.preInitializeRunning) {
                    const page = this.currentSettingsPage;
                    CommandManager.execute(Commands.CLOSE_SETTINGS);
                    UIUtils.showMessageBox(Locale.getString(LocaleId.ui_settings_closed_text), Locale.getString(LocaleId.ui_settings_closed_title));
                    // this.show(page);
                }
            }.bind(this));
        }

    }
    private setupOptions(hasOptionsButton: boolean, hasSoundButton: boolean) {
        if (!hasOptionsButton) {
            if (this.pages.has(SettingsButtons.OPTIONS)) {
                this.pages.delete(SettingsButtons.OPTIONS);
            }
            if (this.navigationActions.has(SettingsButtons.OPTIONS)) {
                this.navigationActions.delete(SettingsButtons.OPTIONS);
            }
        }

        if (!hasSoundButton) {
            if (this.pages.has(SettingsButtons.SOUND)) {
                this.pages.delete(SettingsButtons.SOUND);
            }
            if (this.navigationActions.has(SettingsButtons.SOUND)) {
                this.navigationActions.delete(SettingsButtons.SOUND);
            }
        }
    }
    private setPages() {
        this.pages.set("autoplay", () => this.showAutoPlay());
        this.pages.set("bet", () => this.showBetOptions());
        this.pages.set("settings", () => this.showPayTable());
        this.pages.set("paytable", () => this.showPayTable());
        this.pages.set("sound", () => this.showOptions(SettingsButtons.SOUND));
        this.pages.set("options", () => this.showOptions(SettingsButtons.OPTIONS));
    }

    private setNavigationActions() {
        this.navigationActions.set(SettingsButtons.RIGHT_ARROW, () =>
            this.arrowNavigate("next")
        );
        this.navigationActions.set(SettingsButtons.LEFT_ARROW, () =>
            this.arrowNavigate("previous")
        );
        this.navigationActions.set(SettingsButtons.CLOSE, (e) => {
            e.stopPropagation();
            CommandManager.execute(Commands.CLOSE_SETTINGS);
            SoundController.playSound(SoundVars.BUTTON_CLICK);
        });
        this.navigationActions.set(SettingsButtons.SETTINGS, () => {
            this.showPayTable();
            SoundController.playSound(SoundVars.BUTTON_CLICK);
        }
        );
        this.navigationActions.set(SettingsButtons.AUTOPLAY, () => {
            this.showAutoPlay();
            SoundController.playSound(SoundVars.BUTTON_CLICK);
        }
        );
        this.navigationActions.set(SettingsButtons.BET_OPTIONS, () => {
            this.showBetOptions();
            SoundController.playSound(SoundVars.BUTTON_CLICK);
        }
        );
        this.navigationActions.set(SettingsButtons.SOUND, () => {
            this.showOptions(SettingsButtons.SOUND);
            SoundController.playSound(SoundVars.BUTTON_CLICK);
        }
        );
        this.navigationActions.set(SettingsButtons.HOME, () =>
            CommandManager.execute(Commands.GO_HOME)
        );
        this.navigationActions.set(SettingsButtons.OPTIONS, () => {
            this.showOptions(SettingsButtons.OPTIONS);
            SoundController.playSound(SoundVars.BUTTON_CLICK);
        });
    }

    get minFontSize(): number | string {
        if (Layout.isLandscape()) {
            return this.minFontSizeLandscape
        } else {
            return this.minFontSizePortrait
        }
    }

    get minFontSizePortrait(): number | string {
        return this._minFontSizePortrait
    }
    set minFontSizePortrait(value: number | string) {
        this._minFontSizePortrait = value
    }
    get minFontSizeLandscape(): number | string {
        return this._minFontSizeLandscape
    }
    set minFontSizeLandscape(value: number | string) {
        this._minFontSizeLandscape = value
    }

    protected setBehaviours() {
        this.setBehaviour(UIStates.IDLE, {
            uiToEnable: this.buttons
        });
        this.setBehaviour(UIStates.SPIN, {
            uiToDisable: this.buttons
        });
        this.setBehaviour(UIStates.DEFAULT, {
            uiToDisable: this.buttons
        });
    }
    public hide() {
        this.currentSettingsPage = "";
        super.hide();
    }
    protected calculateMinFontSize(): void {
        if (!this.minFontSize) {
            let fontSize = this.findMinFontSize();
            Layout.isLandscape() ? this.minFontSizeLandscape = fontSize : this.minFontSizePortrait = fontSize;
        }
    }
    protected getBodyString = (key: string, [start, end]: number[]) => {
        let body = "";
        for (let index = start; index <= end; index++) {
            const element = `${key}${index}`;
            body += "● " + Locale.getString(element) + "\n\n";
        }

        return body
    }
    protected findBiggestText(): { name?: string, rules?: [number, number], sceneTextField: string } {
        let config = Configs.settings;
        let result = null;

        if (config.biggestTextTextField) {
            result = {
                sceneTextField: config.biggestTextTextField
            }
        } else {
            let rules = config.rulesData;
            let maxLength = 0
            rules.forEach(obj => {
                let str = this.getBodyString(obj.name, obj.rulesDimensions);
                if (maxLength < str.length) {
                    maxLength = str.length;
                    result = obj
                }
            })

            if (result) {
                if (!GameModel.gameConfig.debugLogging || GameModel.gameConfig.debugLogging.biggestTextWarning === true) {
                    ConsoleUtil.warn(
                        `[SETTINGS] -> Biggest text in current setting rules is in textField: <${result.sceneTextField}>,
                        you can prevent this search (this search down the performance) if you place this text field name in SettingsConfig like <"biggestTextTextField">`,
                    );
                }
            }
        }

        return result
    }
    protected findMinFontSize(): number {
        let config = Configs.settings;
        let result = 0;
        let scenes = config.scenesForCalculatingMinFontSize;
        let bgText = this.findBiggestText();
        if (!bgText) {
            return App.config.minFontSize || 10;
        }

        let sceneName: string = "";

        if (config.biggestTextScene) {
            sceneName = config.biggestTextScene;
        } else {
            sceneName = this.contentLayer.findSceneNameContainsBound(bgText.sceneTextField);
        }

        if (sceneName.length > 0) {
            let scene = this.contentLayer.setScene(sceneName, { textFieldApplyBound: false });
            if (scene.sceneTextFields.has(bgText.sceneTextField)) {
                this.fillTexts(scene, false, true);
                let tx = scene.sceneTextFields.get(bgText.sceneTextField) as TextField;
                result = Number(tx.style.fontSize);
            }

            if (!GameModel.gameConfig.debugLogging || GameModel.gameConfig.debugLogging.biggestTextWarning === true) {
                ConsoleUtil.yellow(
                    `[SETTINGS] -> Biggest text in current setting rules is in textField: <${bgText.sceneTextField}>,
                    you can prevent this search (this search down the performance) if you place this text field name in SettingsConfig like <"biggestTextTextField">.
                    This text field is located in Scene: <${sceneName}>,
                    you can prevent this search (this search down the performance) if you place this scene name in SettingsConfig like <"biggestTextScene">`,
                );
            }
        } else {
            for (let index = 0; index < scenes.length; index++) {
                let scene = this.contentLayer.setScene(scenes[index], { textFieldApplyBound: false });
                if (scene.sceneTextFields.has(bgText.sceneTextField)) {
                    this.fillTexts(scene, false, true);
                    let tx = scene.sceneTextFields.get(bgText.sceneTextField) as TextField;
                    result = Number(tx.style.fontSize);
                    break;
                }
            }
        }

        return result
    }
    public show(page?: string) {
        if (this.preInitializeRunning) {
            return;
        }

        this.calculateMinFontSize();
        super.show();
        this.rightArrow = this.interfaceScene.buttons.get(
            SettingsButtons.RIGHT_ARROW
        );
        this.leftArrow = this.interfaceScene.buttons.get(
            SettingsButtons.LEFT_ARROW
        );
        this.buttons = [];
        this.interfaceScene.buttons.forEach((btn) => {
            if (btn != this.rightArrow && btn != this.leftArrow && btn != this.interfaceScene.buttons.get(SettingsButtons.CLOSE)) {
                if (GameModel.gameConfig.disableAutoplay && btn === this.interfaceScene.buttons.get(SettingsButtons.AUTOPLAY)) {
                    btn.setEnabled(false);
                } else {
                    this.buttons.push(btn);
                }
            }
        });
        this.setBehaviours();
        if (!GameModel.isMobile() && GameModel.urlParams.hidehome) {
            this.interfaceScene.buttons.get(SettingsButtons.HOME).visible = false;
        }
        if (!this.pages.has(page)) {
            page = this.defaultPage;
        }
        this.pages.get(page)();
        const scene = ViewManager.getLayer(DefaultLayers.MenuUI).getCurrentScene();
        let homeBut = scene.buttons.get("home");
        if (!GameModel.homeUrl) {
            homeBut.visible = false;
        }
        if (App.config.isHomeButtonVisible) {
            homeBut.visible = GameModel.isHomeButtonAllowed;
        }
        this.update();
    }

    public update() {
        if (this.currentSettingsPage != "paytable") {

            if (this.leftArrow) {
                this.leftArrow.visible = false;
            }
            if (this.rightArrow) {
                this.rightArrow.visible = false;
            }
        }
    }
    protected showOptions(menuType: SettingsButtons) {
        const isMobile: boolean = GameModel.isMobile();

        if (this.currentSettingsPage == menuType) {
            return;
        }
        this.currentSettingsPage = menuType;
        this.scene = this.contentLayer.setScene(menuType, null, true);

        const musicToggle: SwitchButton = this.scene.buttons.get(SettingsButtons.MUSIC) as SwitchButton;
        const soundToggle: SwitchButton = this.scene.buttons.get(SettingsButtons.SOUND) as SwitchButton;
        let cursorToggle: SwitchButton = null;
        const turboToggle: SwitchButton = this.scene.buttons.get(SettingsButtons.TURBO) as SwitchButton;
        const jackpotToggle: SwitchButton = this.scene.buttons.get(SettingsButtons.JACKPOT) as SwitchButton;
        soundToggle.switch(SoundController.isEffectsEnabled);
        musicToggle.switch(SoundController.isMusicEnabled);

        if (App.config.hasCustomMouseCursor && !isMobile) {
            cursorToggle = this.scene.buttons.get(SettingsButtons.CURSOR) as SwitchButton;
            cursorToggle && cursorToggle.switch(Cursor.isCustom);
        } else {
            const cursorGroup: Container = this.scene.groups.get("cursor");
            if (cursorGroup) {
                cursorGroup.visible = false;
            }
        }

        if (!this.scene.isReused) {
            this.applyFontSize();
            soundToggle.on(PointerEvents.DOWN, () => {
                soundToggle.toggle();
                CommandManager.execute(Commands.TOGGLE_SOUND_FX, soundToggle.isSelected());
                CommandManager.execute(VendorCommandsEnum.TOGGLE_SOUND_BUTTON);
            });

            musicToggle.on(PointerEvents.DOWN, () => {
                musicToggle.toggle();
                CommandManager.execute(Commands.TOGGLE_MUSIC, musicToggle.isSelected());
                CommandManager.execute(VendorCommandsEnum.TOGGLE_SOUND_BUTTON);
            });

            if (jackpotToggle) {
                jackpotToggle.switch(JackpotsModel.playForJackpot);
                jackpotToggle.on(PointerEvents.DOWN, () => {
                    jackpotToggle.toggle();
                    JackpotsModel.playForJackpot = !JackpotsModel.playForJackpot;
                });
            }

            if (cursorToggle && !isMobile) {
                cursorToggle.on(PointerEvents.DOWN, () => {
                    cursorToggle.toggle();
                    CommandManager.execute(Commands.TOGGLE_CURSOR);
                });
            }

            if (turboToggle) {
                turboToggle.switch(GameModel.turboSpin);
                turboToggle.on(PointerEvents.DOWN, () => {
                    turboToggle.toggle();
                    CommandManager.execute(Commands.TOGGLE_TURBO_SPIN);
                });
            }
        }


        this.update();
    }
    public showAutoPlay() {

        if (this.currentSettingsPage === "autoplay") {
            return;
        }
        this.currentSettingsPage = "autoplay";
        this.update();
        let autoPage = InstanceFactory.getClass("AutoplayPage") as BaseUI;
        autoPage.create();
    }
    protected showPayTable() {

        const scenes = Configs.settings.rulesScenes;
        this.update();
        this.payTablePage = 1;
        this.currentSettingsPage = scenes.paytable;
        // remove feature bye rules from game rules if feature will be deactivated by jurisdiction
        let scenesCount = this.parseScenesCount(scenes);

        this.paytablePageScenes = [];
        this.createPagesArray(scenes, scenesCount);
        this.scene = this.contentLayer.setScene(
            this.paytablePageScenes[this.payTablePage - 1],
            { textFieldApplyBound: false },
            true
        );
        this.leftArrow.visible = false;
        this.rightArrow.visible = true;

        if (!this.scene.isReused) {
            this.forceCalculatedBounds(this.scene)
            this.fillTexts();
        }

        this.calculateWins();
    }

    protected createPagesArray(scenes: IRulesScenes, scenesCount: IRulesScenesCount): void {
        Object.entries(scenes).forEach(([key, value]) => {
            this.createPayTablePagesArray(value, scenesCount[key])
        })
    }

    protected parseScenesCount(scenes: IRulesScenes): IRulesScenesCount {
        let scenesCount: IRulesScenesCount = {};
        Object.entries(scenes).forEach(([key, value]) => {
            scenesCount[key] = this.contentLayer.getScenesTypeCount(value);
        })

        let result = this.disableRulesPages(scenesCount);

        return result

    }

    protected disableRulesPages(scenesCount: IRulesScenesCount): IRulesScenesCount {

        let result = Utils.deepClone(scenesCount);

        // if (
        //     ConfigManager.getConfig<IVendorClientConfigRequestData>(ConfigurationTypes.GAME).clientConfig.disableBuyFeature
        // ) {
        //     result.gameRules -= 1;
        // }
        // if (
        //     ConfigManager.getConfig<IVendorClientConfigRequestData>(ConfigurationTypes.GAME).clientConfig.hideGameRules
        // ) {
        //     result.gameRules = 0;
        // }
        // if (
        //     ConfigManager.getConfig<IVendorClientConfigRequestData>(ConfigurationTypes.GAME).clientConfig.autoplayDisable
        // ) {
        //     result.autoplayRules = 0;
        // }

        return result
    }
    protected createPayTablePagesArray(sceneName: string, pagesCount: number) {
        for (let i = 0; i < pagesCount; i++) {
            if (!this.hasPageRestriction(sceneName + "~" + (i + 1))) {
                this.paytablePageScenes.push(sceneName + "~" + (i + 1));
            }
        }
    }

    protected hasPageRestriction(pageName: string): boolean {
        let hasRestriction: boolean = false;
        const pageRestrictions = Configs.settings.pageRestrictions;
        if (pageRestrictions) {
            pageRestrictions.forEach((rule) => {
                if (rule.pageName == pageName && rule.hasRestriction()) {
                    hasRestriction = true;
                }
            });
        }

        return hasRestriction;
    }

    protected switchPayTables(direction: string, pagesCount: number) {
        if (direction === "previous" && this.payTablePage > 1) {
            this.payTablePage--;
        }
        if (direction === "next" && this.payTablePage < pagesCount) {
            this.payTablePage++;
        }
        this.leftArrow.visible = !(this.payTablePage === 1);
        this.rightArrow.visible = !(this.payTablePage === pagesCount);
        this.scene = this.contentLayer.setScene(
            this.paytablePageScenes[this.payTablePage - 1],
            { textFieldApplyBound: false },
            true
        );

        this.forceCalculatedBounds(this.scene);
        this.fillTexts();
        if (this.scene.buttons && this.scene.buttons.has(SettingsButtons.HISTORY)) {
            this.scene.buttons.get(SettingsButtons.HISTORY).once(PointerEvents.DOWN, (e) => {
                CommandManager.execute(Commands.REQUEST_HISTORY),
                    SoundController.playSound(SoundVars.BUTTON_CLICK);
                e.stopPropagation();
            })
        }

        this.calculateWins();
    }
    protected fillTexts(scene: SceneView = this.scene, applyFontSize: boolean = true, applyText: boolean = true) {
        const rules = Configs.settings.rulesData;
        let textFieldName = null;
        let body = "";
        let result: { textFieldName: string | null, body: string }[] = [];

        if (scene.sceneTextFields) {
            for (let index = 0; index < rules.length; index++) {
                const rule = rules[index];
                if (scene.sceneTextFields.has(rule.sceneTextField)) {
                    textFieldName = rule.sceneTextField;
                    body = this.getBodyString(rule.name, rule.rulesDimensions);
                    result.push({
                        textFieldName,
                        body
                    })
                }

            }
        }

        result.forEach(({ textFieldName, body }) => {
            if (textFieldName === null && body.length === 0 && applyFontSize) {
                this.applyFontSize(scene)
            }

            if (textFieldName && body.length > 0 && applyText) {
                if (applyFontSize) {
                    this.setFixedFontSize(scene, textFieldName)
                }
                this.setText(scene, textFieldName, body)
            }
        })

    }
    protected applyFontSize(scene: SceneView = this.scene): void {
        if (scene.sceneTextFields) {
            const textFields = Configs.settings.applyMinFontSizeTextFields;
            textFields.forEach(tf => {
                if (scene.sceneTextFields.has(tf)) {
                    this.applyMinFontSize(scene.sceneTextFields.get(tf) as TextField);
                }
            })
        }
    }
    protected forceCalculatedBounds = (scene: SceneView) => {
        if (scene.sceneTextFields) {
            let forceCalculatedBoundFields = Configs.settings.forceCalculateBoundFields || [];
            let forceCalculatedBoundScenes = Configs.settings.forceCalculateBoundScenes || [];

            if (forceCalculatedBoundScenes.length > 0 && forceCalculatedBoundScenes.includes(this.scene.name.split("-")[1])) {
                this.scene.sceneTextFields?.forEach(txf => {
                    (txf as TextField).applyBound();
                })

            } else if (forceCalculatedBoundFields.length > 0) {
                scene.sceneTextFields.forEach(txf => {
                    if (forceCalculatedBoundFields.includes((txf as TextField).bound.id)) {
                        (txf as TextField).applyBound();
                    }
                })
            }
        }
    }
    protected applyMinFontSize(textField: TextField): void {
        textField.style.fontSize = this.minFontSize;
        textField.fixFontSize = this.minFontSize;
    }
    protected setFixedFontSize(scene: SceneView, textFieldName: string): void {
        let textField = scene.sceneTextFields.get(textFieldName) as TextField;
        textField.fixFontSize = this.minFontSize;
    }
    protected setText(scene: SceneView = this.scene, textFieldName: string, body: string): void {
        let textField = scene.sceneTextFields.get(textFieldName) as TextField;
        textField.text = body;
    }
    private calculateWins(scene: SceneView = this.scene) {
        let config = Configs.settings;
        if (scene.sceneMoneyFields) {
            scene.sceneMoneyFields.forEach((value, key) => {
                if (key.startsWith("pt_sym_")) {
                    value.value = 0;
                }
            });
        }

        if (scene.sceneMoneyFields && config) {
            let scatterPTLetters = GameModel.gameConfig.scatterPTLetters;
            let freeSpinSymbolId = GameModel.serverGameConfig?.freeSpinSymbol;
            let scatters;

            if (Number.isFinite(freeSpinSymbolId)) {
                scatters = GameModel.gameConfig.paytableSymbolsMap[freeSpinSymbolId];
            } else if (scatterPTLetters) {
                scatters = GameModel.gameConfig.scatterPTLetters;
            } else {
                this.hide();
                throw new Error(`Missing freeSpinSymbolId and scatterPTLetters!`);
            }

            config.ptMap.forEach(({ key, multiplier }) => {
                if (scene.sceneMoneyFields.has(key)) {
                    scene.sceneMoneyFields.get(key).centerVertical();
                    scene.sceneMoneyFields.get(key).value =
                        (scatters.find(letter => letter == (key.match(/[A-Z]/g))))
                            ? BetModel.totalBet * multiplier
                            : (BetModel.totalBet / BetModel.betDivisor) * multiplier;
                }
            });
        }
    }
    protected showBetOptions() {

        if (this.currentSettingsPage == "bet") {
            return;
        }
        this.currentSettingsPage = "bet";
        this.update();
        this.scene = this.contentLayer.setScene("bet");
        this.applyFontSize();


        let j = 0;

        let validBetsOptions = Configs.bet.getBetOptions();
        while (this.scene.buttons.has("betAmount~" + (j + 1))) {
            let value = validBetsOptions[j];
            this.setBet(value, j);
            j++
        }
    }
    protected setBet = (value: number, j: number): void => {
        let btn = this.scene.buttons.get(
            "betAmount~" + (j + 1)
        ) as SwitchButton;
        btn.switch(BetModel.coinSizeIndex == j);
        let betField = this.scene.sceneMoneyFields.get(
            "betAmount~" + (j + 1)
        ) as MoneyField;
        if (!value) {
            btn.visible = false;
            betField.visible = false;
        } else {
            betField.value = value as number;
            this.assignInterraction(
                [Commands.SET_BET, Commands.SAVE_SETTINGS],
                btn,
                SoundVars.BUTTON_CLICK,
                // BetModel.getPossibleBetByIndex(BetModel.creditValues.indexOf(value))
                this.getBetOptionsBtnInteractionParams(value)
            );

            betField.applyLabelSettings();
        }
    }
    protected getBetOptionsBtnInteractionParams(value: number) {
        return BetModel.getPossibleBetByIndex(BetModel.creditValues.indexOf(value))
    }
    protected arrowNavigate(direction: "previous" | "next" = "next") {
        SoundController.playSound(SoundVars.BUTTON_CLICK);
        switch (this.currentSettingsPage) {
            case "paytable":
                this.switchPayTables(direction, this.paytablePageScenes.length);
                break;
            default:
                break;
        }
    }

    public preInitialize(initial: boolean) {
        if (initial) {
            this.show("settings");
            this.preInitializeRunning = true;
            this.contentLayer.interactive = false;
            this.interfaceLayer.interactive = false;
            this.backgroundLayer.interactive = false;
            this.contentLayer.visible = false;
            this.interfaceLayer.visible = false;
            this.backgroundLayer.visible = false;
            const settingsButton = ViewManager.getLayer(DefaultLayers.BetBar).setScene().buttons.get(UIButtons.Settings);
            const lastButtonState = settingsButton.state;

            const delay = 50;
            for (let i = 0; i < this.paytablePageScenes.length; i++) {
                setTimeout(() => {
                    this.switchPayTables("next", this.paytablePageScenes.length);
                    settingsButton.setEnabled(false);
                }, delay * i);
            }

            setTimeout(() => {
                this.hide();
                this.contentLayer.visible = true;
                this.interfaceLayer.visible = true;
                this.backgroundLayer.visible = true;
                settingsButton.setEnabled(lastButtonState != "DISABLED");
                this.preInitializeRunning = false;
            }, this.paytablePageScenes.length * delay)
        } else {
            // TODO: Implement the logic, when mobile device has been rotated for 1st time.
        }
    }
}
